import TalRevAPI from '../services/api';

export const testApiConnection = async (): Promise<{
  success: boolean;
  message: string;
  details?: any;
}> => {
  try {
    console.log('🔍 Testing API connection...');
    
    // Test health check endpoint
    const healthResult = await TalRevAPI.healthCheck();
    console.log('✅ Health check successful:', healthResult);
    
    return {
      success: true,
      message: 'API connection successful',
      details: healthResult,
    };
  } catch (error: any) {
    console.error('❌ API connection failed:', error);
    
    let message = 'Unknown error occurred';
    
    if (error.code === 'ECONNREFUSED') {
      message = 'Backend server is not running. Please start the FastAPI server at http://localhost:8000';
    } else if (error.response?.status === 404) {
      message = 'Health endpoint not found. Check if the backend API routes are properly configured.';
    } else if (error.message) {
      message = error.message;
    }
    
    return {
      success: false,
      message,
      details: {
        code: error.code,
        status: error.response?.status,
        statusText: error.response?.statusText,
        url: error.config?.url,
      },
    };
  }
};

// Function to test a full workflow (for development/debugging)
export const testFullWorkflow = async (testFile?: File): Promise<void> => {
  console.log('🧪 Testing full API workflow...');
  
  try {
    // Step 1: Health check
    console.log('Step 1: Health check...');
    await TalRevAPI.healthCheck();
    console.log('✅ Health check passed');
    
    if (testFile) {
      // Step 2: Upload file
      console.log('Step 2: Upload file...');
      const uploadResult = await TalRevAPI.uploadTalentCard(testFile);
      console.log('✅ Upload successful:', uploadResult);
      
      const talentCardId = uploadResult.id;
      
      // Step 3: Check processing status
      console.log('Step 3: Check processing status...');
      const processingStatus = await TalRevAPI.getProcessingStatus(talentCardId);
      console.log('✅ Processing status retrieved:', processingStatus);
      
      // If completed, test results endpoints
      if (processingStatus.status === 'completed') {
        // Step 4: Get talent card data
        console.log('Step 4: Get talent card data...');
        await TalRevAPI.getTalentCard(talentCardId);
        console.log('✅ Talent card data retrieved');
        
        // Step 5: Get scoring results
        console.log('Step 5: Get scoring results...');
        await TalRevAPI.getScoringResults(talentCardId);
        console.log('✅ Scoring results retrieved');
        
        // Step 6: Test chat
        console.log('Step 6: Test chat...');
        const chatResponse = await TalRevAPI.sendChatMessage(
          talentCardId,
          'What are the key strengths?'
        );
        console.log('✅ Chat response received:', chatResponse);
      }
    }
    
    console.log('🎉 Full workflow test completed successfully!');
  } catch (error) {
    console.error('❌ Workflow test failed:', error);
    throw error;
  }
};